export { default } from "./Timestamp";
